import { Box, Button, Typography } from "@mui/material";
import { Mail } from "@mui/icons-material";
import  rev_logo from "../../assets/image/revoptimal_logo_medium_res.png"

export default function ScreenTooSmall() {
  return (
    <Box sx={{display:"flex", height:"100vh", width:1/1, background:"#fdfdfd"}}>
      <Box sx={{margin:"auto", textAlign:"center"}}>
        <img src={rev_logo} alt="RevOptimal logo" style={{width:"75vw", paddingBottom:"24px"}}/>
        <Typography>The RevOptimal platform is best experienced on a larger screen</Typography>
        <Button
          href="https://revoptimal.com/contact/"
          startIcon={<Mail />}
          sx={{ fontWeight: "bold", marginTop:"24px" }}
          variant="text"
          size="large"
          target="_blank"
        >
          Contact Us
        </Button>
      </Box>
    </Box>
  );
}